import { Injectable } from "@angular/core";
import { PrePurchaseResponseCart } from "./interfaces/pre-purchase.interface";
import { AddressPurchase, EstablishmentInfo } from "../sync-prices-cart/interfaces/purchase.interface";
import { EstablishmentInfoService } from "../info-establishment/establishment-info.service";
import { BehaviorSubject, map, Observable, shareReplay, switchMap, throwError } from "rxjs";
import { UserGetAddressCleanService } from "../user-get-address-clean/user-get-address-clean.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { CostTrackingService } from "../google/cost-tracking/cost-tracking.service";
import { IsDeliveryFreeService } from "../is-delivery-free/is-delivery-free.service";
import { Store } from "@ngrx/store";
import { ShippingState } from "../../../store/shipping/shipping.reducer";
import * as ShippingActions from '../../../store/shipping/shipping.actions';
import { AuthService } from "../auth.service";
import { CartModel } from "../../../store/cart/cart.model";
import { CartStorageService } from "../cartStorage/cart-storage.service";
import { PrePurchaseCostsService } from "./pre-purchase-costos.service";
import { NotificationsService } from "../../../shared/components/notifications/service/notifications.service";
import { ShowMultiplicadorService } from "../show-multiplicador/show-multiplicador.service";

@Injectable({
  providedIn: 'root'
})

export class PrePurchaseService {
  private phoneEstablishment: string = '';
  private phoneEstablishmentSubject = new BehaviorSubject<string>('');
  private infoEstablishment: EstablishmentInfo = {
    id_products: [],
    id_establishment: 0
  };
  private apiUrl = environment.apiUrl;
  constructor(
    private establishmentInfoService: EstablishmentInfoService,
    private userGetAddressCleanService: UserGetAddressCleanService,
    private http: HttpClient,
    private costTrackingService: CostTrackingService,
    private isDeliveryFreeService: IsDeliveryFreeService,
    private store: Store<{ shipping: ShippingState, cart: CartModel }>,
    private authService: AuthService,
    private cartStorageService: CartStorageService,
    private prePurchaseCostsService: PrePurchaseCostsService,
    private notificationService: NotificationsService,
         private showMultiplicadorService:ShowMultiplicadorService,

  ) {
    this.infoEstablishment = this.establishmentInfoService.getInfoEstablishment();

    this.store.select(state => state.shipping).subscribe((shipping) => {
      this.phoneEstablishment = shipping.phone;
    })
    this.phoneEstablishmentSubject.next(this.phoneEstablishment);
  }

  getCurrentAddress(): Observable<AddressPurchase> {
    return this.userGetAddressCleanService.getCurrentAddress().pipe(
      map(address => {
        // Process the address data if needed
        return address;
      })
    );
  }
  setPhoneEstablishment(phone: string): void {
    this.store.dispatch(
      ShippingActions.setPhoneEstablishment({ phone }));
    this.phoneEstablishmentSubject.next(phone);
  }
  getCoordinates(): Observable<PrePurchaseResponseCart> {
    // Ya no necesitamos obtener infoEstablishment
    // this.infoEstablishment = this.establishmentInfoService.getInfoEstablishment();
    // console.log('asdsada', this.infoEstablishment);

    return this.getCurrentAddress().pipe(
      switchMap(currentAddress => {
        if (!currentAddress) {
          return throwError(() => new Error('No se encontró dirección actual'));
        }

        // console.log('Enviando petición a pre_purchase con token');
        // Solo enviamos el token de autenticación, sin parámetros adicionales
        return this.http.get<PrePurchaseResponseCart>(`${this.apiUrl}/pre_purchase`, {
          headers: new HttpHeaders({
            Authorization: `Bearer ${this.authService.getToken()}`
          }),
        }).pipe(
          switchMap(response => {
            // console.log('Respuesta recibida de pre_purchase:', response);
            // Convertir a Observable para mantener la cadena de observables
            return new Observable<PrePurchaseResponseCart>(observer => {
              (async () => {
                try {
                  // Verificar si hay datos en la respuesta, independientemente del status
                  if (!response.data) {
                    throw new Error('No data received from pre_purchase');
                  }

                  // console.log('Estructura de response.data:', Object.keys(response.data));

                  let distance = 0, duration = 0;
                  this.isDeliveryFreeService.setMountDeliveryForFree(
                    Number(response.data.establishment[0].monto_envio_gratis ?? 0)
                  );
                  this.setPhoneEstablishment(response.data.establishment[0].phone);

                  // Manejar el cálculo de distancia con try-catch

                  // console.log('cooordenandassss',
                    //{
                      //latitude: currentAddress.ad_latitude.toString(),
                      //longitude: currentAddress.ad_longitude.toString()
                    //}
                  //);

                  try {
                    const result = await this.costTrackingService.calculateDistance(
                      {
                        latitude: currentAddress.ad_latitude.toString(),
                        longitude: currentAddress.ad_longitude.toString()
                      },
                      response.data.establishment[0]
                    );

                    distance = result.distance;
                    duration = result.duration;
                    // console.log('distancia y tiempo', distance, duration);





                    this.prePurchaseCostsService.sendCosts({
                      id_address: currentAddress.ad_id,
                      time: duration * 60
                    }).subscribe({
                      next: (res) => {
                        this.showMultiplicadorService.setMultiplicador(res.data.multiplicador!);
                        // console.log('VALOR DEL MULTIPLICADOR', res.data.multiplicador);
                        this.store.dispatch(ShippingActions.SetDistanceKm({ distanceKm: res.data.distanceKm.toString() }));
                        this.store.dispatch(
                          ShippingActions.setTarifaBase({ tarifaBase: res.data.tarifa_base?.toString()! }));
                        this.store.dispatch(
                          ShippingActions.setTarifaServicio({ tarifaServicio: res.data.tarifa_servicio?.toString()! }));
                        this.isDeliveryFreeService.setShippingCost(res.data.costo_envio!);
                      },
                      error: (err) => {
                          this.notificationService.addNotification({
                        message: 'Tú dirección no es correcta, verifique',
                        type: 'error'

                      });
                        console.error('Error en sendCosts:', err);
                        observer.error(new Error('Error en sendCosts'));
                        return;
                      }
                    });
                  } catch (distanceError) {
                    console.warn('Error calculando distancia:', distanceError);
                    this.notificationService.addNotification({
                      message: 'Error calculando la distancia. Verifique su dirección.',
                      type: 'error'
                    });
                    observer.error(new Error('Error calculando distancia'));
                    return;
                  }

                  // console.log('ahora la distancia y el tiempo es ', distance, duration);

                  // Validar que la distancia y duración no sean 0
                  if (distance === 0 || duration === 0) {
                    console.warn('Distancia o duración es 0:', { distance, duration });
                    this.notificationService.addNotification({
                      message: 'No se pudo calcular la ruta. Verifique su dirección.',
                      type: 'error'
                    });
                    observer.error(new Error('Distancia o duración inválida'));
                    return;
                  }

                  // Verificar si products_disable existe y tiene elementos

                  if (response.data.products_disable && Array.isArray(response.data.products_disable)) {
                    if (response.data.products_disable.length > 0) {
                      try {
                        // console.log('Productos deshabilitados:', JSON.stringify(response.data.products_disable));
                        await this.cartStorageService.updateCart(
                          response.data.products_disable.map(product => ({
                            pd_id: product.pd_id  // Mantenemos pd_id como propiedad
                          }))
                        )
                        // console.log('Carrito actualizado correctamente');
                      } catch (cartError) {
                        console.error('Error actualizando carrito:', cartError);
                        // Continuar sin actualizar el carrito
                      }
                    } else {
                      // console.log('No hay productos deshabilitados para actualizar');
                    }
                  } else {
                    // console.log('products_disable no existe o no es un array');
                  }
                  observer.next(response);
                  observer.complete();
                } catch (error) {
                  console.error('Error en el procesamiento:', error);
                  observer.error(error); // Cambiar a observer.error para propagar el error correctamente
                }
              })();
            });
          })
        );
      }),
      shareReplay(1)
    );
  }

}
